module.exports = __webpack_public_path__ + "img/business-card.00809d6f.png";